import { Injectable, signal } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class UrlParametersState {
	readonly urlParameters = signal<UrlParameters | null>(null)
}

export interface UrlParameters {
	readonly uuid: string
	readonly ticket: string
}
